import { Measurement, MeasurementType } from "modules/common/components/Alarms/constants";
import {
    IAlarmGroup,
    SelectedCountyStation,
} from "modules/common/components/Alarms/types/AlarmModels";
import { Station, StationType } from "modules/common/components/Alarms/types/AlarmsForm";

export const getInitialFormData = (alarmGroupModalData: IAlarmGroup, stations: Station[]) => {
    const newCountiesStations: SelectedCountyStation[] = [];
    const newMeasurements: Measurement[] = [];
    const alarms = alarmGroupModalData.stationAlarms ?? [];

    for (const alarm of alarms) {
        if (!alarm) {
            continue;
        }

        const station = stations.find(
            s => s.id === alarm.metosStationId || s.id === alarm.pinovaStationId
        );
        const isMetos = alarm.metosStation !== undefined;
        const isPinova = alarm.pinovaStation !== undefined;

        if (!station || !station.zupanija) {
            continue;
        }

        const existingCountyStation = newCountiesStations.find(
            s => s.stationId === station.id && s.countyId === station.zupanija.id
        );

        if (!existingCountyStation) {
            newCountiesStations.push({
                countyId: station.zupanija.id,
                stationId: station.id,
                stationType: station.type,
            });
        }

        const existingMeasurement = newMeasurements.find(
            m => m.measurementType === alarm.measurementType
        );

        if (!existingMeasurement) {
            const stationTypes = [
                ...(isMetos ? [StationType.Metos] : []),
                ...(isPinova ? [StationType.Pinova] : []),
            ];

            const {
                measurementType,
                measurementUnit,
                type,
                amount,
                lookbackDays,
                valueRange,
                phenophaseId,
            } = alarm;

            newMeasurements.push({
                id: measurementType as MeasurementType,
                measurementType,
                measurementUnit,
                phenophaseId,
                type,
                amount,
                lookbackDays,
                valueRange,
                stationTypes,
            });
        }
    }

    return {
        newCountiesStations,
        newMeasurements,
    };
};
